export default "__VITE_ASSET__CW5k3Wzq__"